/* src/app/shared-components/mb-button/mb-button.component.scss */
:host ::ng-deep {
  display: block;
  margin: 0.5rem;
}
:host ::ng-deep button {
  width: 100%;
  min-width: 100px;
  color: rgb(255, 255, 255);
  background-color: rgba(46, 125, 229, 0.9);
  border: 1px solid rgb(46, 125, 229);
  border-radius: 0.25rem;
  padding: 1rem 0.75rem;
  outline: 0;
}
:host ::ng-deep button:hover {
  background-color: #2e7de5;
}
:host ::ng-deep button:active {
  filter: brightness(0.75);
}
:host ::ng-deep button.success {
  background-color: rgba(0, 165, 28, 0.9);
  border-color: rgba(0, 165, 28, 0.9);
}
:host ::ng-deep button.success:hover {
  background-color: #00a51c;
}
:host ::ng-deep button.error {
  background-color: rgba(208, 32, 32, 0.9);
  border-color: rgba(208, 32, 32, 0.9);
}
:host ::ng-deep button.error:hover {
  background-color: #d02020;
}
:host ::ng-deep button.warning {
  background-color: rgba(226, 155, 0, 0.9);
  border-color: rgba(226, 155, 0, 0.9);
}
:host ::ng-deep button.warning:hover {
  background-color: #e29b00;
}
:host ::ng-deep button.flat {
  color: rgb(46, 125, 229);
  background-color: transparent;
  border: 0;
}
:host ::ng-deep button.flat:hover {
  background-color: rgba(46, 125, 229, 0.15);
}
:host ::ng-deep button.flat.success {
  background-color: transparent;
  border-color: transparent;
  color: rgb(0, 165, 28);
}
:host ::ng-deep button.flat.success:hover {
  background-color: rgba(0, 165, 28, 0.15);
}
:host ::ng-deep button.flat.error {
  background-color: transparent;
  border-color: transparent;
  color: rgb(208, 32, 32);
}
:host ::ng-deep button.flat.error:hover {
  background-color: rgba(208, 32, 32, 0.15);
}
:host ::ng-deep button.flat.warning {
  background-color: transparent;
  border-color: transparent;
  color: rgb(226, 155, 0);
}
:host ::ng-deep button.flat.warning:hover {
  background-color: rgba(226, 155, 0, 0.15);
}
.success button {
  background-color: rgba(0, 165, 28, 0.9);
}
.success button:hover {
  background-color: #00a51c;
}
/*# sourceMappingURL=mb-button.component.css.map */
